// Mirrored from packages/backend/src/modules/db-explorer/db-explorer.types.ts

export interface DbQueryRequest {
  entityRef: string;
  env: string;
  envUrl: string;
  sql: string;
}

export interface DbQueryResponse {
  columns: string[];
  rows: string[][];
  rowCount: number;
  truncated: boolean;
}

// --- Schema types ---

export interface DbSchemaColumn {
  name: string;
  dataType: string;
  isNullable: boolean;
  defaultValue: string | null;
  isPrimaryKey: boolean;
}

export interface DbSchemaForeignKey {
  sourceTable: string;
  sourceColumn: string;
  targetTable: string;
  targetColumn: string;
}

export interface DbSchemaTable {
  name: string;
  columns: DbSchemaColumn[];
}

export interface DbSchemaResponse {
  tables: DbSchemaTable[];
  foreignKeys: DbSchemaForeignKey[];
}

export interface DbSchemaAnnotation {
  [envName: string]: {
    commitSha: string;
    tables: DbSchemaTable[];
    foreignKeys: DbSchemaForeignKey[];
  };
}

export const DB_SCHEMA_ANNOTATION = 'kpc.io/db-schema' as const;
